export default __webpack_public_path__ + "static/media/bottomright.88dbfa83.png";